import { SearchService } from '@/services/pa/search.service';
import * as FileDownload from 'js-file-download';
import { Parser } from 'json2csv';

import {
    PA_HISTORY_SEARCH,
    PA_HISTORY_SEARCH_METRICS,
    PA_HISTORY_EXPORT
} from './actions.type';
import {
    SET_PA_SEARCH_COMPLETE,
    SET_PA_SEARCH_METRICS_COMPLETE,
    SET_PA_SEARCH_BUSY,
    SET_PA_EXPORT_BUSY,
    SAVE_PA_EXPORT_FIELDS
} from './mutations.type';
import {
    ERROR_HANDLE_ERROR
} from '../error/actions.type';

const initialState = {
    searchCriteria: {},
    searchResults: null,
    isSearchBusy: false,
    isExportBusy: false,
    savedExportFields: [],
    searchMetricsResults: []
};

export const state = Object.assign({}, initialState);

export const actions = {
    [PA_HISTORY_SEARCH](context, criteria) {
        context.commit(SET_PA_SEARCH_BUSY, true);
        return SearchService.query(criteria)
            .then(({ data }) => {
                context.commit(SET_PA_SEARCH_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_PA_SEARCH_COMPLETE, data);
                }
                return data;
            },
            (err) => {
                context.commit(SET_PA_SEARCH_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            });
    },
    [PA_HISTORY_SEARCH_METRICS](context, criteria) {
        context.commit(SET_PA_SEARCH_BUSY, true);
        return SearchService.queryMetrics(criteria)
            .then(({ data }) => {
                context.commit(SET_PA_SEARCH_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_PA_SEARCH_METRICS_COMPLETE, data);
                }
                return data;
            },
            (err) => {
                context.commit(SET_PA_SEARCH_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            });
    },
    [PA_HISTORY_EXPORT](context, criteria) {
        context.commit(SET_PA_EXPORT_BUSY, true);
        return SearchService.search(criteria)
            .then(({ data }) => {
                context.commit(SET_PA_EXPORT_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    var selectedFields = criteria.selectedFields.map(function(f) {
                      return f.key;
                    });

                    var customRecords = mapRecords(data.records, selectedFields);

                    const parser = new Parser({selectedFields});
                    const csv = parser.parse(customRecords);
                    FileDownload(csv, 'PAExport.csv');
                }
            },
            (err) => {
                context.commit(SET_PA_SEARCH_BUSY, false);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            });
    }
};

function mapRecords(hits, selectedFields) {
  let records = [];
  hits.forEach((hit) => {
      var returnedObject = {};
      selectedFields.forEach((field) => {
          returnedObject[field] = hit[field];
      });
      records.push(returnedObject);
  });
  return records;
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
    [SET_PA_SEARCH_COMPLETE](state, results) {
      state.searchResults = results;
    },
    [SET_PA_EXPORT_BUSY](state, isBusy) {
      state.isExportBusy = isBusy;
    },
    [SET_PA_SEARCH_BUSY](state, isBusy) {
      state.isSearchBusy = isBusy;
    },
    [SAVE_PA_EXPORT_FIELDS](state, fields) {
      state.savedExportFields = fields;
    },
    [SET_PA_SEARCH_METRICS_COMPLETE](state, results) {
      state.searchMetricsResults = results;
    }
};

const getters = {};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/pa/pa.module.js